<template>
  <section class="sec-top-intro d-flex flex-wrap">
    <div class="box-top-slide w-50">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202312_01.jpg">
      </div>
      <div class="img-top-slide_text_01">
        <h2 class="mb-3 text-left"><span>忙しいからこそ、忘れないで。</span><br>手肌もアンチエイジング</h2>
        <p>おすすめのハンドクリームと<br>正しいケアって？</p>
      </div>
    </div>
    <div class="box-top-slide w-50">
      <div class="img-top-slide">
        <img src="@/assets/img/column/202312_02.jpg">
      </div>
      <div class="img-top-slide_text_02">
        <h2 class="mb-3 text-left"><span>手肌年齢の</span><br>老化を改善</h2>
        <p>今すぐ始められる<br>ハンドケアをご紹介</p>
      </div>
    </div>
  </section>

  <section class="column_content">    
    <h2 class="mt-5 pt-5 mb-3">手は老化があらわれやすい？</h2>
    <div class="text-center mb-5 pb-5">
      <p class="mb-3">日頃から顔の「シミ」や「しわ」を防止するべく、丁寧なお手入れを気にかけている方は多いことでしょう。</p>
      <p class="mb-3">では「手」については、どうでしょうか？</p>
      <p class="mb-3">ふと自分の手を見た時に</p>
      <p class="mb-3">「なんか老けて見える・・？」</p>
      <p>そう感じたことがある人は少なくないかもしれません。</p>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-50">
        <h3 class="mb-3"><small>実年齢＋10歳...！？</small><br>手は年齢が出やすいパーツ</h3>
        <p class="mb-3">手元は老化を感じやすいパーツであることは本当です。</p>
        <p class="mb-3">主な原因として</p>
        <p class="mb-3">・一年中露出しているので紫外線の影響を受けやすい</p>
        <p class="mb-3">・顔の皮膚に比べ、手元は新陳代謝のスピード（ターンオーバー）が遅い</p>
        <p class="mb-3">・手は皮脂腺が少なく乾燥しやすい</p>
        <p class="mb-3">・外部からの刺激が多い</p>
        <p class="mb-3">など、納得の理由ばかりです。</p>
        <p>特にターンオーバーが遅いため、一度できたシミやシワも目立ちやすく、老化を感じやすいというわけです。</p>
      </div>
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202312_03.jpg">
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202312_04.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-40">
        <h3 class="mb-3"><small>今すぐ始めたい！</small><br>どんなケアが手元のアンチエイジングに効果的？</h3>
        <p class="mb-3">手元も実年齢に！そう思うのは女性だけではなく、男性も抱えるお悩みだと思います。</p>
        <p>手元の「ハンドケア」で重要なのは、根本的に手荒れする原因を予防することです。</p>
      </div>
    </div>

    <div class="pb-3 d-flex flex-wrap">
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">手洗いは優しくしっかりと</h3>
        <p class="mb-3">手洗いは優しくしっかりと<br>最も大切なことは、手をきちんと洗い清潔な状態を保つことです。ただ洗いすぎも禁物。</p>
        <p>とくに敏感肌の方は自分のお肌に合った、優しい成分のハンドソープなどを選ぶことをおすすめします。</p>
      </div>
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">手元のUVケアも忘れないで</h3>
        <p class="mb-3">手元は一年を通して、紫外線の影響を受ける環境が多いです。紫外線は美肌の大敵！シミやシワの原因にもなりますし、手は顔よりもターンオーバーが遅いため一度シミになるとなかなか厄介。シミになる前にしっかりとUVケアを。</p>
        <p>顔や首元に日焼け止めを塗る際に、手元にも日焼け止めを塗ることをクセづけましょう。</p>
      </div>
    </div>
    <div class="mb-5 pb-5 d-flex flex-wrap">
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">お湯は人肌のぬるま湯</h3>
        <p class="mb-3">高温のお湯は手元の必要な皮脂まで洗い流してしまうことで、乾燥を促し手荒れはもちろん、シワの原因にも。</p>
        <p>適温は32℃～35℃ぐらいのぬるま湯です。寒い時期はつい暖かいお湯で洗ってしまいがちですが、ここも日頃から気をつけたいところです。</p>
      </div>
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">家事の時は、手荒れ対策を</h3>
        <p class="mb-3">家事をする際に欠かせないのが、食器洗いなどの水仕事。ゴム手袋を使ったり、自然由来の食器洗い洗剤を見直したり、水で洗剤を薄めて使ったり。</p>
        <p>洗浄後はハンドクリームでしっかりと保湿してあげましょう。</p>
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_text feature-row_item_text_left w-40">
        <h3 class="mb-3"><small>さらに効果を高める</small><br>正しいハンドケア</h3>
        <p>まずは日頃から手荒れの対策を気にかける事が大切ですが、対策だけではなく効果的なハンドケアを行うことがおすすめです。</p>
      </div>
      <div class="feature-row_item_image w-60">
        <img src="@/assets/img/column/202312_05.jpg">
      </div>
    </div>

    <div class="pb-3 d-flex flex-wrap">
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">ハンドクリームは最も大切</h3>
        <p class="mb-3">ハンドクリームを塗ることは、最も手軽であり大切なハンドケアのひとつです。乾燥を防ぎ、保湿をすることで皮膚の水分量があがると言われています。</p>
        <p>さらに血行促進や硬くなった角質を柔らかくするといった効果も期待できます。</p>
      </div>
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">ハンドクリームの効果を高めコツ</h3>
        <p class="mb-3">ハンドクリームを塗るポイントをご紹介。ハンドクリームを一度手のひらで温めて塗ることで、テクスチャーが柔らかくなり肌馴染みが良くなります。</p>
        <p>塗る時は乾燥しやすい手の甲から、指先に向かって手全体に塗り広げていきましょう。スペシャルケアとして、化粧水を塗った後でハンドクリームを重ねるワンステップも！</p>
      </div>
    </div>
    <div class="mb-5 pb-5 d-flex flex-wrap">
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">こまめにハンドクリームを塗り直す</h3>
        <p class="mb-3">ハンドクリームをこまめに塗り直すことも大切です。1日に3~5回が目安ですが、実は乾燥を感じる「前」に保湿することも重要です。手洗い後もしっかり保湿してあげましょう。</p>
        <p>外出先でも塗り直しができるように、持ち運びすることを忘れずに。</p>
      </div>
      <div class="w-50 px-3 py-3">
        <h3 class="mb-3">自分に合ったハンドクリームを選ぶ</h3>
        <p class="mb-3">自分の肌やお悩み別、テクスチャーや好みの香りなどによって、自分に合ったハンドクリームを使用することがおすすめです。</p>
        <p>乾燥が気になる方は「ヒアルロン酸」などの保湿成分が配合されたハンドクリームを選びましょう。</p>
      </div>
    </div>

    <div class="feature-row">
      <div class="feature-row_item_image w-50">
        <img src="@/assets/img/column/202312_06.jpg">
      </div>
      <div class="feature-row_item_text feature-row_item_text_right w-50">
        <h3 class="mb-3">こんなお悩みないですか？</h3>
        <p class="mb-3">ハンドケアはしっかりしたいから、ハンドクリームは塗りたい。</p>
        <p class="mb-3">だけどすぐに仕事に取り掛かりたいけど、ベタついてしまう...</p>
        <p>みなさん一度は感じたことがあるお悩みかもしれません。</p>
      </div>
    </div>

    <div class="layer_01  my-5 py-5">
      <img src="@/assets/img/column/layer-bg_02.jpg">
      <div class="layer-text">
        <h2 class="mb-3">手元も美肌に。すこやかに。</h2>
        <p class="mb-3">マナビス化粧品のハンドクリームは、手肌ケアに最適なことはもちろん、<br>ヒアルロン酸や植物由来の成分を贅沢に配合。</p>
        <p>しっかりとケアをしながらも、優しい香りで<br>食事や家事、仕事の邪魔にもなりません。</p>
      </div>
    </div>

    <div class="feature-row pt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">ハンドクリームの開発秘話</h3>
        <p class="mb-3">この商品は「保湿力はあるけれど、ペンや道具が滑ってしまう従来のハンドクリームは使いづらい。すぐに仕事ができるようなハンドクリームが欲しい。」</p>
        <p class="mb-3">そんなお客様の声に応えて開発されました。</p>
        <p class="mb-3">通常多くのハンドクリームは水の中に油が入っている「O/W」処方ですが、マナビス化粧品は油の中に水が入っている「W/O+シリコンベース」処方を採用。</p>
        <p>開発には多くの試行錯誤があり、「油の種類」「分量」「混ぜる時の温度」「混ぜる速度」「手元の配合から工場にスケールアップした時の作り方」など、長い時間をかけてやっと完成しました。</p>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/202312_07.jpg">
      </div>
    </div>

    <div class="feature-row pt-5 mt-5">
      <div class="feature-row_item_text feature-row_item_text_left w-60">
        <h3 class="mb-3">HAND CARE<br>ハンドクリーム</h3>
        <p class="mb-3">¥3,300</p>
        <p class="mb-3">保湿クリーム 30g×3本</p>
        <p class="mb-3">＼新パッケージ／</p>
        <p class="mb-3">ヒアルロン酸配合<br>フレッシュフローラルブーケの香り</p>
        <p class="mb-3">するする伸びて、しっとりサラサラ。<br>やさしい香り、うるおいのベールで、<br>包みこむように手肌を守る。</p>
        <p class="mb-3">ベストセラー商品が新パッケージになって登場。</p>
        <p class="mb-3">3本セットで素敵な化粧箱入り。</p>
        <p>大切な方へのプレゼントにはもちろん、それぞれをお家、バッグ、オフィスにと使い分けにも便利。</p>
        <div class="mt-5">
          <router-link to="/products" class="btn">
            商品一覧へ
          </router-link>
        </div>
      </div>
      <div class="feature-row_item_image w-40">
        <img src="@/assets/img/column/handcare_handcream_202312.jpg">
      </div>
    </div>
   
    <div class="layer_02 pt-5">
      <img src="@/assets/img/column/202312_08.jpg">
      <div class="layer-text">
        <div class="layer-text-inner">
          <h2 class="mb-3 text-left"><span>マナビス化粧品</span><br>ハンドケアシリーズ</h2>
          <p>やさしく、いたわるように。手肌のケアを。</p>
        </div>
      </div>
    </div>

    <div class="text-center my-5 py-5">
      <p class="mb-3">すうっとなじむ、アルコール成分配合ジェル。</p>
      <p class="mb-3">ふわふわの泡で洗い上げる、マイルドなソープ。</p>
      <p>うるおいのベールで包みこむような、クリーム。</p>
    </div>
    
    <h2 class="my-5 py-5">HAND CAREシリーズ</h2>
    <div class="feature-row feature-row_product_list">
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/handcare_handcreamset_202312.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">【新商品】マナビス ハンドクリーム（３本セット）</div>
              <div class="feature-row_product_cate">HAND CARE</div>
              <div class="feature-row_product_price">¥3,300</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/handcare_handgelmini_202312.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">ハンドジェル ミニ</div>
              <div class="feature-row_product_cate">HAND CARE</div>
              <div class="feature-row_product_price">¥800</div>
            </div>
        </router-link>
      </div>
      <div class="feature-row_product_item">
        <router-link to="/products">
            <img src="@/assets/img/column/handcare_handsoap_202312.jpg">
            <div class="feature-row_product_detail text-center">
              <div class="feature-row_product_title">ハンドソープ</div>
              <div class="feature-row_product_cate">HAND CARE</div>
              <div class="feature-row_product_price">¥980</div>
            </div>
        </router-link>
      </div>
    </div>

    <div class="text-center">
      <p class="mb-3">清潔な暮らしを守るためのエチケット。その陰で、美しさは犠牲になっていませんか。</p>
      <p class="mb-3">ふと手を眺め、悲しくなることはありませんか。</p>
      <p class="mb-3">そんなときには、上質なハンドケアで、指の先まで、しなやかな時間を。</p>
      <p class="mb-3">やさしいうるおいと香りに包まれて、ゆっくり呼吸をすれば、やわらかな気持ちが満ちてきます。</p>
      <p>そして、所作さえも美しく。</p>
    </div>
  </section>


  <!-- トップに戻るボタン -->
  <button id="page-top" class="btn" v-on:click="scrollTop">
    TOP
  </button>

</template>

<style scoped>
.column_content h2,.column_content h3 {
  font-weight: 500 !important;
}
small {
  font-size: .7em;
}

.feature-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 50px;
}
.feature-row_item_image img {
  width: 100%;
}
.feature-row_item_text h3 {
  font-size: 1.25em;
}

button#page-top {
  position: fixed;
  right: 20px;
  bottom: 20px;
  z-index: 100;
}


.layer_01 {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: url('../../assets/img/column/layer-bg_02.jpg');
  background-size: cover;
  background-position: center;
  min-height: 400px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
  padding: 20px; /* テキストと画像の端の間に余白を設定 */
}
.layer_01 img {
  display: none; /* 画像は背景として使用するので非表示にします */
}
.layer_01 .layer-text {
  padding: 10px;
  text-align: center;
  max-width: 90%; /* 文字が画像からはみ出さないように最大幅を設定 */
  word-wrap: break-word; /* 長い単語が折り返されるようにする */
  color: #424242;
  font-weight: 500;
}
.layer_01 .layer-text .fs-2 {
  font-size: 2em;
}

.feature-row_product_list {
  align-items: inherit;
}
.feature-row_product_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}
.feature-row_product_detail {
  color: #333;
}
.feature-row_product_cate {
  font-size: .8em;
  color: #6b6b67;
  opacity: .65;
}

.feature-row_voice_list {
  align-items: baseline;
}
.feature-row_voice_list path.a {
  fill: none;
  stroke: #000;
  stroke-width: 2px;
}
.feature-row_voice_list .icon svg {
  width: 70px;
}
.feature-row_voice_list .feature-row_voice_item {
  width: 33%;
  padding: 5px;
  text-align: center;
}

.box-top-slide {
  position: relative;
}
.img-top-slide_text_01 {
  position: absolute;
  top: 10%;
  left: 30px;
}
.img-top-slide_text_02 {
  position: absolute;
  bottom: 10%;
  left: 30px;
}
.img-top-slide_text_01 h2,.img-top-slide_text_02 h2 {
  font-size: 2em;
  font-weight: 500 !important;
}
.img-top-slide_text_01 h2 span,.img-top-slide_text_02 h2 span {
  font-size: .6em;
}

.layer_02 .layer-text {
  background-color: #cacaca;
  padding: 10px;
}
.layer_02 .layer-text .layer-text-inner {
  background-color: #fff;
  padding: 15px;
}
.layer_02 .layer-text .layer-text-inner h2 span {
  font-size: .6em;
}
@media screen and (min-width: 991px) {
    .layer_02 {
      position: relative;
      display: flex;
      align-items: baseline;
      background-image: url('../../assets/img/column/202312_08.jpg');
      background-size: cover;
      min-height: 750px; /* 最小高さを設定しておくと、極端に小さくなるのを防げます */
      padding: 60px; /* テキストと画像の端の間に余白を設定 */
      justify-content: end;
    }
    .layer_02 img {
      display: none; /* 画像は背景として使用するので非表示にします */
    }
    .layer_02 .layer-text {
      padding: 15px;
      max-width: 52%; /* 文字が画像からはみ出さないように最大幅を設定 */
      word-wrap: break-word; /* 長い単語が折り返されるようにする */
      color: #424242;
      background-color: #fff;
    }
}
@media screen and (max-width: 699px) {
    .img-top-slide_text h2 {
      font-size: inherit;
    }
    .img-top-slide_text h2 span {
      font-size: .8em;
    }
}
@media screen and (min-width: 769px) {
   .feature-row_item_text_right {
    padding-left: 60px;
   }
   .feature-row_item_text_left {
    padding-right: 60px;
   }
   .w-40 {
    width: 40%;
   }
   .w-60 {
    width: 60%;
   }

}
@media screen and (min-width: 1px) and (max-width: 768px) {
  .column_content h2 {
    margin-bottom: 40px;
  }
  .feature-row {
    flex-direction: column;
  }
  .feature-row_item_image {
    order: 1;
    margin-bottom: 15px;
  }
  .feature-row_item_text {
    order: 2;
  }
  .feature-row_voice_item, .feature-row_product_item {
      width: 100% !important;
  }
  .w-50, .w-25, .w-75 {
    width: 100% !important;
  }
  .layer-text {
    font-size: .8em;
  }
  .layer_01 .layer-text .fs-2 {
    font-size: 1.5em;
  }
}
</style>

<script>
import $ from "jquery";

$(function() {
 var topBtn = $('#page-top');    
 topBtn.hide();
 //スクロールが500に達したらボタン表示
 $(window).scroll(function () {
 if ($(this).scrollTop() > 500) {
 topBtn.fadeIn();
        } else {
 topBtn.fadeOut();
        }
    });
    
});

// ページ内リンク
export default{
  data: () => {
    return {isActive: []}
  },
  mounted (){
    window.scroll(0, 0);
    for(let i = 0; i < 2; i++) {
      this.isActive[i] = false
    }
  },
  methods: {
    scrollToAnchorPoint(refName) {
      const el = this.$refs[refName]
      el.scrollIntoView({ behavior: 'smooth'})
    },
    openInfo(ref) {
      console.log(ref)
      this.isActive[ref] = true
      console.log(this.isActive[ref])
    },
    closeInfo(ref) {
      console.log(ref)
      this.isActive[ref] = false
      console.log(this.isActive[ref])
    },
    scrollTop(){
      window.scrollTo({
      top: 0,
      behavior: "smooth"
      })
    }
  }
}

</script>